import { InputChoiceType } from "App.types";
import BackendChoiceSelectInput from "atoms/BackendChoiceSelectInput";
import { reversePricePositions } from "misc/typedDataHelpers";
import { InvoiceKindEnum, InvoiceRecordType } from "pages/Booking/Booking.types";
import { PriceRecordType } from "pages/SharedRecords.types";
import { InputProps, useTranslate } from "react-admin";
import { useFormContext } from "react-hook-form";

type InvoiceKindInputPropsType = {
  parentInvoice: InvoiceRecordType;
  initialPrice: PriceRecordType | null;
} & Omit<InputProps, "source">;

export default function InvoiceKindInput({ parentInvoice, initialPrice, ...rest }: InvoiceKindInputPropsType) {
  const formContext = useFormContext();
  const translate = useTranslate();

  const setInvoiceName = (value: InvoiceKindEnum) => {
    const newName = translate(`invoice.titles.${value.toLowerCase()}`, { invoiceNumber: parentInvoice.invoice_number });
    formContext.setValue("name", newName);

    if (value === InvoiceKindEnum.Reversal && initialPrice) {
      formContext.setValue("price", reversePricePositions(initialPrice));
    } else {
      formContext.setValue("price", initialPrice);
    }
  };

  const filterChoices = (choices: InputChoiceType[]) => choices.filter((c) => c.value !== "STANDARD");

  return (
    <BackendChoiceSelectInput
      {...rest}
      onChange={setInvoiceName}
      source="kind"
      choicesType="invoice_kinds"
      filterChoices={filterChoices}
    />
  );
}
